<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Список устройств</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Добавить устройство</li>
        </ol>
    </nav>

    <div class="form-narrow">
        <div class="form-row">
            <div class="mb-4">
                <label class="form-label" for="input_name_type_id">
                    Тип устройства <span class="color-red">*</span>
                </label>
                <v-select
                    v-model="formData.type_id"
                    :items="types"
                    item-title="name"
                    item-value="id"
                    variant="outlined"
                    color="primary"
                    density="compact"
                    clearable
                    @update:menu="$removeFocus"
                    @click:clear="$removeFocus"
                    @click:control="$removeFocus">
                    <template #no-data>
                        <span>Данные не найдены</span>
                    </template>
                </v-select>
            </div>
        </div>

        <div class="form-row">
            <div class="mb-4">
                <label class="form-label" for="input_name_location_id">
                    Адрес <span class="color-red">*</span>
                </label>
                <v-autocomplete
                    v-model="selectedLocation"
                    v-model:search="search"
                    :items="locations"
                    return-object
                    :item-title="formatItemTitle"
                    variant="outlined"
                    color="primary"
                    density="compact"
                    clearable
                    autocomplete="off"
                    @update:menu="$removeFocus"
                    @click:clear="$removeFocus"
                    @click:control="$removeFocus">
                    <template #no-data>
                        <v-list-item>
                            <span>Данные не найдены</span>
                        </v-list-item>
                    </template>
                </v-autocomplete>
            </div>
        </div>

        <div class="form-row">
            <div class="mb-4">
                <label class="form-label" for="input_name_type_id">
                    Статус <span class="color-red">*</span>
                </label>
                <v-select
                    v-model="formData.status_device"
                    :items="statuses"
                    item-title="name"
                    item-value="id"
                    variant="outlined"
                    color="primary"
                    density="compact"
                    clearable
                    @update:menu="$removeFocus"
                    @click:clear="$removeFocus"
                    @click:control="$removeFocus">
                    <template #no-data>
                        <span>Данные не найдены</span>
                    </template>
                </v-select>
            </div>
        </div>

        <div class="form-row">
            <div class="mb-4">
                <label class="form-label mt-3">Клиент</label>
                <div v-if="selectedLocation">
                    {{ selectedLocation.client_name }}
                </div>
                <label class="form-label mt-3">Бренд</label>
                <div v-if="selectedLocation">
                    {{ selectedLocation.brand_name }}
                </div>
                <label class="form-label mt-3">Организация</label>
                <div v-if="selectedLocation">
                    {{ selectedLocation.org_name }}
                </div>
                <label class="form-label mt-3">График работы</label>
                <div v-if="selectedLocation">
                    {{ selectedLocation.worktime }}
                </div>
            </div>
        </div>

        <div class="form-row">
            <div class="mb-4">
                <label class="form-label" for="sshPort">SSH PORT <span class="color-red">*</span></label>
                <input type="text" class="form-control" id="sshPort" v-model="formData.ssh_port" placeholder="Введите порт">
            </div>
        </div>

        <div class="form-row">
            <div class="mb-4">
                <label class="form-label" for="ip">IP <span class="color-red">*</span></label>
                <input type="text" class="form-control" id="ip" v-model="formData.ip" placeholder="Введите ip адрес">
            </div>
        </div>

        <div class="form-row">
            <div class="mb-4">
                <label class="form-label" for="content-update-start">
                    Время начала обновления контента устройства <span class="color-red">*</span>
                </label>
                <input type="time" class="form-control" id="content-update-start" v-model="formData.update_start" placeholder="Введите время начала обновления контента устройства">
            </div>
        </div>

        <div class="form-row">
            <div class="mb-4">
                <label class="form-label" for="content-update-interval">
                    Интервал обновления контента устройства <span class="color-red">*</span>
                </label>
                <input type="time" class="form-control" id="content-update-interval" v-model="formData.update_interval" placeholder="Введите интервал обновления контента устройства">
            </div>
        </div>
    </div>

    <div class="d-flex align-items-center justify-content-start">
        <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить'" @btnClick="createDevice"/>
        <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
    </div>

    <Alert />
</template>

<script>
import ConfirmBtn from "../../../../elements/ConfirmBtn.vue";
import Device from "../../../../models/Device";
import Alert from "../../../alerts/Alert.vue";
import { mapMutations } from "vuex/dist/vuex.cjs.js";

export default {
    name: "DeviceCreateComponent",
    components: { Alert, ConfirmBtn },
    props: {
        route_back: String,
        route_device_types_search: String,
        route_locations_search: String,
        route_worktimes_search: String,
        route_create: String
    },
    data: function () {
       return {
           device: new Device({
               route_device_types_search: this.route_device_types_search,
               route_locations_search: this.route_locations_search,
               route_worktimes_search: this.route_worktimes_search,
               route_create: this.route_create
           }),
           statuses: [
               {
                   id: 6,
                   name: 'Не выбрано'
               },
               {
                   id: 3,
                   name: 'На ремонте'
               },
               {
                   id: 4,
                   name: 'Перемещение'
               },
               {
                   id: 5,
                   name: 'Утилизировано/списано'
               },
           ],
           search: '',
           types: [],
           locations: [],
           worktimes: [],
           selectedLocation: null,
           addressAndNumber: null,
           isOpenDropDown: false,
           formData: {
               type_id: null,
               location_id: null,
               update_start: null,
               update_interval: null,
               additional_params: null,
               ip: null,
               ssh_port: null,
               status_device: null
           },
           forms: {
               searchingDevices: {
                   selectedItem: null,
               },
           },
       }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        createDevice: async function () {
            if (!this.formData.type_id) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите тип устройства' });
                this.toggleLoading();
                return;
            }

            if (!this.formData.location_id) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите адрес устройства' });
                this.toggleLoading();
                return;
            }

            if (!this.formData.status_device) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите статус устройства' });
                this.toggleLoading();
                return;
            }

            if (!this.formData.update_start) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите время начала обновления контента устройства' });
                this.toggleLoading();
                return;
            }

            if (!this.formData.update_interval) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите интервал обновления контента устройства' });
                this.toggleLoading();
                return;
            }

            if (!this.formData.ip) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите IP' });
                this.toggleLoading();
                return;
            }

            if (!this.formData.ssh_port) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите SSH PORT' });
                this.toggleLoading();
                return;
            }

            let result = await this.device.create(this.formData);
            if(result) {
                window.location.href = this.route_back;
            } else {
                console.log('error: create_device');
                this.toggleLoading();
            }
        },
        searchDeviceTypes: async function () {
            let types = await this.device.deviceTypes();
            this.types = types.items;
        },
        searchLocations: async function () {
            const data = await axios.get(this.route_locations_search, {
                params: {
                    address_number: this.addressAndNumber
                }
            }).then(response => {
                return response.data
            });

            this.locations = data.status == "ok" ? data.items : [];
        },
        searchWorktimes: async function () {
            let worktimes = await this.device.worktimes();
            this.worktimes = worktimes.items;
        },
        selectLocation: function (location) {
            this.location_id = location.id;
            this.selectedLocation = {...location};
            this.addressAndNumber = '';
        },
        formatItemTitle(item) {
            return `${item.number} ${item.street}`;
        },
    },
    watch: {
        selectedLocation(location) {
            this.formData.location_id = location?.id ? location.id : null;
            this.addressAndNumber = '';
        }
    },
    mounted() {
        this.searchDeviceTypes();
        this.searchWorktimes();
        this.searchLocations();
    }
}
</script>

<style scoped>
    #search_address_input {
        /* border-bottom: none;  */
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
    }

    #input_name_location_id {
        border-top: none;
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
    }

    .app-dropdown {
        border-radius: 5px;
        position: relative;
    }

    .app-dropdown .manager {
        border: 1px solid #ddd;
        border-radius: 4px;
    }

    .app-dropdown .items-block {
        position: relative;
        height: 200px;
        overflow: auto;
        z-index: 9999;
        background-color: #fff;
        border-bottom: 1px solid #ddd;
        border-left: 1px solid #ddd;
        border-right: 1px solid #ddd;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .app-dropdown .items-block .searching-block {
        position: sticky;
        top: 0;
        background-color: #fff;
    }

    .app-dropdown .items-block .searching-block input {
        border-bottom: 1px solid #ddd;
        border-top: none;
        border-radius: 0;
        border-left: none;
        border-right: none;
    }

    .app-dropdown .items {
        position: absolute;
        width: 100%;
    }

    .app-dropdown .items .item {
        padding: 0 10px;
        cursor: pointer;
        font-size: 16px;
    }

    .app-dropdown .items .item:hover {
        background-color: #3c7af0;
        color: white;
    }

    .app-dropdown .hidden {
        display: none;
    }

    .app-dropdown .manager {
        padding: 15px;
        height: 40px;
        cursor: pointer;
    }

    .app-dropdown .manager .button {
        background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAICAYAAAAiJnXPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACeSURBVHgBjZDBDcMgDEVtqwN0hK7QETpCb8ClZYNkhG6QbtAb147ABs0G7Qg5coJ+okSKEFJAQthf/9nG7Jy7E9GJGo+IfA94PTN/8B4bmCnGeBat9S+ldG0ACIDNfskJAg+h32F6Y8x7HnFVIAzo+Ki5s66UGtacSwMW88Ifb5uRnijYbT1SQiGEDpXHpcNYAlXIWjsBvCD0uNUF/QEMBD/7Z34xowAAAABJRU5ErkJggg==");
        background-repeat: no-repeat;
        background-position: center right;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        font-size: 16px;
    }

    .app-dropdown .shade {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        z-index: 999;
        min-height: 100vh;
        overflow: hidden;
    }

    .app-dropdown .content {
        position: absolute;
        width: 100%;
        height: 200px;
    }
</style>
